import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import LoadingButton from "@mui/lab/LoadingButton";
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import Grid from "@mui/material/Grid";
import jwt_decode from 'jwt-decode';
import { FC, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { fetchEstimatePreview } from '../../store/estimateStore/estimateThunk';
import { InvoicePreviewPayload } from "../../utils/invoice.types";


// Preview Voucher
const EstimatePreview: FC = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const voucherType = searchParams.get("type");
  const { isLoggedIn } = useAppSelector((state) => state.auth);
  const [pdfLocation, setPdfLocation] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);
  const [showSendButton, setShowSendButton] = useState(false);
  const [openShareInvoiceRecieptDrawer, setOpenShareInvoiceRecieptDrawer] = useState<boolean>(false);

  const openShareInvoiceDrawer = (event: any) => {
    console.log(" openShareInvoiceDrawer drawer called");
    setOpenShareInvoiceRecieptDrawer(true);
    event.stopPropagation();
  };

  const handleCloseDrawer = () => {
    setOpenShareInvoiceRecieptDrawer(false);
  };

  useEffect(() => {
    const templateId = searchParams.get("templateId");
    const paramPdfLocation = searchParams.get("pdfLocation");
    console.log(paramPdfLocation);
    setShowSendButton(true);

    const getPreview = async () => {
      let reqObj: InvoicePreviewPayload = { invoiceId: invoiceId, templateId: templateId };
      let estimatePreviewResponse: any = await dispatch(fetchEstimatePreview(reqObj));
      let location = null;
      if (estimatePreviewResponse?.payload) {
        if (estimatePreviewResponse.payload.length > 0) {
          location = estimatePreviewResponse.payload[0].Location;
        } else {
          location = estimatePreviewResponse.payload.Location;
        }
        setPdfLocation(location);
      }
      setIsLoading(false);
    };

    if (templateId) {
      if (paramPdfLocation) {
        console.log("called params");
        console.log(paramPdfLocation)
        setPdfLocation(paramPdfLocation);
        setIsLoading(false);
      } else {
        console.log("called api call ");
        getPreview();
      }

    } else {
      if (invoiceId) {
        console.log(invoiceId);
        try {
          let token: any = jwt_decode(invoiceId);
          console.log(token);
          setPdfLocation(token.pdfLocation);
          setIsLoading(false);
        } catch (error) {
          console.log("error in decoding jwt code ==> ", error);
        }
      }
    }
  }, [invoiceId])

  const actionChangeHandler = (data: any) => {
    console.log(data);
    // setIsRefersh(data.isRefersh);
  }

  return (
    (isLoading ? <CircularProgress /> :
      <>
        <Grid container p={0} spacing={2} position={'fixed'} mt={-2} zIndex={999}>
          <Grid item xs={8}>
            <Box sx={{ borderRadius: '12px', border: '3px solid #e9ecf1', backgroundColor: '#fff' }}>
              <Grid container>
                <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, pt: 1.5, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
                  <div style={{ float: 'right', marginTop: -5, marginRight: -5 }}>


                    {/* <CustomizedEstimateMenus type={props.type} row={props.row} actionChangeHandler={actionChangeHandler} /> */}
                    {<LoadingButton
                      className={'buttonContainedRoot'}
                      size='small'
                      type="submit"
                      name={'submit'}
                      // onClick={(e) => onSubmit(invoice)}
                      // loading={status === ApiStatus.LOADING}
                      style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7, marginRight: 10 }}
                      variant="contained"
                    >
                      {`Actions`}
                    </LoadingButton>}

                  </div>
                  <IconButton
                    // onClick={() => {
                    //   const s = { ...invoice };
                    //   s.clientAddress.active = false;
                    //   setInvoice(s);
                    //   methods.reset();
                    //   onCancel();
                    // }}
                    style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: -5, marginRight: 10, marginLeft: -5 }}
                    size='small'
                  >
                    <Tooltip title="Back"><NavigateBeforeOutlinedIcon style={{ fontSize: 20 }} /></Tooltip>
                  </IconButton>
                  <h3 style={{ marginTop: -1, fontWeight: 600 }}>{`Preview`}</h3>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <div style={{ height: '10%', backgroundColor: '#fafafb', position: 'sticky', top: 0 }} />
        {/* {isLoggedIn &&   
              <Box style={{ "width": "70vw" }}>
                <Stack direction="row"
                  justifyContent="space-between"
                  alignItems="baseline" sx={{ mb: { xs: 0.9, sm: 0.9 } }}
                  style={{ "float": "right", "paddingBottom": "20px" }}>
                  <Box onClick={() => { }}
                    sx={{ cursor: "pointer" }}
                  >
                    {showSendButton &&
                      
                      <Button
                        style={{paddingBottom: '10px'}}
                        disableElevation
                        sx={{ mt: "20px" }}
                        size="large"
                        type="submit"
                        variant="contained"
                        color="primary"
                        onClick={(e) => openShareInvoiceDrawer(e)}
                        >
                        <ShareIcon  style={{"marginRight": '10px'}}/>
                        Share Estimate
                      </Button>}
                  </Box>
                </Stack>
              </Box>
            } */}
        {/* <p style={{ "clear": "both" }}></p> */}
        <Box>
          <object style={{ height: "85vh", width: "100%", borderRadius: 20 }} contextMenu="true" data={pdfLocation} type="application/pdf">
          </object>
        </Box>
      </>
    )
  );
};

export default EstimatePreview;
